import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SENDER_TYPES } from '../../../containers/chat/slice/constants';
import { Message } from '../../../containers/chat/slice/types';
import { useAdminSlice } from '../slice';
import { selectIsSessionTimelineLoading, selectSessionTimelineItems } from '../slice/selectors';

export default function useSessionTimeline(sessionId: string | null) {
  const dispatch = useDispatch();
  const { actions } = useAdminSlice();
  const timelineItems = useSelector(selectSessionTimelineItems);
  const isLoading = useSelector(selectIsSessionTimelineLoading);

  useEffect(() => {
    if (!sessionId) {
      dispatch(actions.clearSessionTimeline());
      return;
    }

    dispatch(actions.getSessionTimeline(sessionId));
  }, [actions, dispatch, sessionId]);

  const messages = useMemo<Message[]>(
    () =>
      timelineItems.flatMap((item) => [
        {
          _id: `${item._id}-user`,
          sender: SENDER_TYPES.USER,
          message: item.userMessage,
          createdAt: item.createdAt,
          sessionId: item.sessionId,
        },
        {
          _id: `${item._id}-assistant`,
          sender: SENDER_TYPES.ASSISTANT,
          message: item.aiAnswer,
          createdAt: item.createdAt,
          sessionId: item.sessionId,
        },
      ]),
    [timelineItems],
  );

  return { isLoading, messages };
}
